<template>
    <div class="ly_elec_wrap">
        <me-collapes @collapesCb="collapesCb" :treeTitle="title">
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :title="title"
                :treeLoading="treeLoading"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :defaultCheckKeys="defaultCheckKeys"
                :treeToolBar="treeToolBar"
                @handleTreeNodeClick="handleTreeNodeClick"
                :defaultExpandedKeys="defaultExpandedKeys"
                :isSingle="true"
            ></me-tree>
        </me-collapes>
        <div class="ly_data_wrap">
            <el-tabs v-model="tabVal" type="card" @tab-click="handleTabClick" class="leader-tab">
                <el-tab-pane label="电量分析" name="first" v-if="selectObj.is_electricity == 1">
                    <ly-monitor :id="selectObj.point_id"></ly-monitor>
                </el-tab-pane>
                <el-tab-pane label="瞬时量分析" name="second" v-if="selectObj.is_kind == 1">
                    <ly-instant :id="selectObj.point_id"></ly-instant>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import monitor from "./components/ly_monitor.vue";
import instant from "./components/ly_instant.vue";
import * as api from "../../../http/Use_electricity_monitor";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes,
        "ly-monitor": monitor,
        "ly-instant": instant,
    },
    data() {
        return {
            treeData: [],
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            defaultCheckKeys: [],
            defaultExpandedKeys: [],
            title: "采集点选择",
            treeLoading: false,
            treeToolBar: false,
            contWidth: false,
            tabVal: "first", //默认电量
            // selectPid: "", //选中的树id
            selectObj: {},
        }
    },
    created() {
        this.getUnitPointList();
    },
    methods: {
        //获取采集点
        getUnitPointList() {
            api.getUnitPointList({ point_class_id: '001' }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;
                    this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    this.defaultExpandedKeys = [res.bus_json.length > 0 && res.bus_json[0].point_id]
                }
            });
        },
        handleTreeNodeClick(sth) {
            this.selectObj = sth;
            // this.defaultCheckKeys = [sth];
            if (sth.is_kind == 0) {
                this.tabVal = "first";
            }
        },
        handleTabClick(tab) {
            if (tab.name == 'first') {
                // 电量分析
            } else if (tab.name == 'second') {
                // 瞬时量分析
            }
        }
    }
}
</script>
<style lang="scss">
.ly_elec_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    padding: 0 40px;
    box-sizing: border-box;
    .ly_data_wrap {
        width: calc(100% - 280px);
        height: 100%;
        padding-left: 20px;
        box-sizing: border-box;
    }
}
</style>